
import * as ipxStaticRuntime$z8pjPdJVDT from '/Users/pavel/Work/xsquare-2024/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 550,
    "md": 768,
    "lg": 1150,
    "xl": 1350,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "avif",
    "webp",
    "webp"
  ],
  "quality": 100
}

imageOptions.providers = {
  ['ipxStatic']: { provider: ipxStaticRuntime$z8pjPdJVDT, defaults: {} }
}
        